/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './physio-item.reducer';

export const PhysioItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const physioItemEntity = useAppSelector(state => state.physioItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="physioItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.physioItem.detail.title">PhysioItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.physioItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{physioItemEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.physioItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{physioItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.physioItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{physioItemEntity.lastupdated}</dd>
          <dt>
            <span id="measurement">
              <Translate contentKey="tinyMedicRestApp.physioItem.measurement">Measurement</Translate>
            </span>
          </dt>
          <dd>{physioItemEntity.measurement}</dd>
          <dt>
            <span id="methodName">
              <Translate contentKey="tinyMedicRestApp.physioItem.methodName">Method Name</Translate>
            </span>
          </dt>
          <dd>{physioItemEntity.methodName}</dd>
          <dt>
            <span id="sortOrder">
              <Translate contentKey="tinyMedicRestApp.physioItem.sortOrder">Sort Order</Translate>
            </span>
          </dt>
          <dd>{physioItemEntity.sortOrder}</dd>
          <dt>
            <span id="testLocalAbbrev">
              <Translate contentKey="tinyMedicRestApp.physioItem.testLocalAbbrev">Test Local Abbrev</Translate>
            </span>
          </dt>
          <dd>{physioItemEntity.testLocalAbbrev}</dd>
          <dt>
            <span id="testName">
              <Translate contentKey="tinyMedicRestApp.physioItem.testName">Test Name</Translate>
            </span>
          </dt>
          <dd>{physioItemEntity.testName}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.physioItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{physioItemEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.physioItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{physioItemEntity.microSec}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.physioItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{physioItemEntity.cursor}</dd>
          <dt>
            <span id="charge">
              <Translate contentKey="tinyMedicRestApp.physioItem.charge">Charge</Translate>
            </span>
          </dt>
          <dd>{physioItemEntity.charge}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.physioItem.category">Category</Translate>
          </dt>
          <dd>{physioItemEntity.category ? physioItemEntity.category.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.physioItem.hospital">Hospital</Translate>
          </dt>
          <dd>{physioItemEntity.hospital ? physioItemEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/physio-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/physio-item/${physioItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PhysioItemDetail;
